// src/data/cars.js
export const carBrands = [
  {
    slug: "hertz",
    name: "Hertz",
    code: "ZE",
    region: "USA / Global",
    summary:
      "A leading global car rental company offering premium vehicles, luxury collections, and corporate rental solutions across thousands of airport and neighborhood locations.",
  },
  {
    slug: "enterprise",
    name: "Enterprise",
    code: "ET",
    region: "USA / Global",
    summary:
      "Known for exceptional customer service and the 'We'll Pick You Up' guarantee, offering a massive fleet of everyday vehicles, trucks, and SUVs.",
  },
  {
    slug: "alamo",
    name: "Alamo",
    code: "AL",
    region: "USA / Global",
    summary:
      "Focused on leisure travelers, offering hassle-free, low-cost car rentals for family vacations with self-serve kiosks at major destinations.",
  },
  {
    slug: "avis",
    name: "Avis",
    code: "ZI",
    region: "USA / Global",
    summary:
      "Renowned for premium business travel and loyalty programs, offering high-quality vehicles and expedited services for frequent renters.",
  },
  {
    slug: "budget",
    name: "Budget",
    code: "ZD",
    region: "USA / Global",
    summary:
      "A value-oriented brand popular among leisure and budget-conscious travelers, offering reliable cars, SUVs, and moving trucks.",
  },
  {
    slug: "national",
    name: "National",
    code: "ZL",
    region: "USA / Global",
    summary:
      "Designed for frequent business travelers, featuring the Emerald Club which allows members to bypass the counter and choose their own vehicle.",
  },
  {
    slug: "dollar",
    name: "Dollar",
    code: "ZR",
    region: "USA / Global",
    summary:
      "A family-friendly rental company offering affordable rates, reliable vehicles, and a straightforward rental process at major airport locations.",
  },
  {
    slug: "thrifty",
    name: "Thrifty",
    code: "ZT",
    region: "USA / Global",
    summary:
      "Geared towards cost-conscious leisure travelers, providing great deals on a wide selection of vehicles for vacations and long road trips.",
  },
  {
    slug: "sixt",
    name: "Sixt",
    code: "SX",
    region: "USA / Global",
    summary:
      "A premium international brand with a rapidly growing US presence, specializing in luxury cars, sports cars, and high-end SUVs at competitive prices.",
  },
  {
    slug: "payless",
    name: "Payless",
    code: "ZA",
    region: "USA / Global",
    summary:
      "Provides deep discounts and budget-friendly rental options for price-sensitive travelers, operating primarily in major tourist markets.",
  },
  {
    slug: "fox",
    name: "Fox Rent A Car",
    code: "FX",
    region: "USA / Global",
    summary:
      "A discount car rental brand catering to budget travelers, offering a diverse fleet and aggressive pricing near major US airports.",
  },
  {
    slug: "ace",
    name: "Ace Rent A Car",
    code: "AC",
    region: "USA / Global",
    summary:
      "The largest chain of independent car rental operators, known for offering affordable rates and personalized, localized customer service.",
  },
  {
    slug: "advantage",
    name: "Advantage",
    code: "AD",
    region: "USA",
    summary:
      "A value-focused agency providing economical rental options primarily catering to leisure and tourism markets at key US destinations.",
  },
];

export const findCarBrandBySlug = (slug) =>
  carBrands.find((brand) => brand.slug === slug);
